import { render, staticRenderFns } from "./HeaderWindow.vue?vue&type=template&id=2543a298&scoped=true"
import script from "./HeaderWindow.vue?vue&type=script&lang=js"
export * from "./HeaderWindow.vue?vue&type=script&lang=js"
import style0 from "./HeaderWindow.vue?vue&type=style&index=0&id=2543a298&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2543a298",
  null
  
)

export default component.exports